import { NgModule }      from '@angular/core';
import { TxnStatusFilter } from '../filters/txnstatus.pipe';
import { TxnDeliveryStatusFilter } from '../filters/txndeliverystatus.pipe';
import { CustFilter } from '../filters/custFilter.pipe';
import { PrdFilter } from '../filters/prdFilter.pipe';
import { TxnHistFilter } from '../filters/txnHistFilter.pipe';
import { OrdStatusFilter }  from '../filters/ordStatusFilter.pipe';
import { NumFormatter }  from '../filters/num-formatter.pipe';

 @NgModule({
     imports:        [],
     declarations:   [TxnStatusFilter,TxnDeliveryStatusFilter,CustFilter,PrdFilter,TxnHistFilter,OrdStatusFilter, NumFormatter],
     exports:        [TxnStatusFilter,TxnDeliveryStatusFilter,CustFilter,PrdFilter,TxnHistFilter,OrdStatusFilter, NumFormatter]
 })

 export class PipeModule {

   static forRoot() {
      return {
          ngModule: PipeModule,
          providers: [NumFormatter],
      };
   }
 } 


// WEBPACK FOOTER //
// ./src/app/pipe.module.ts